// Generated by CoffeeScript 2.7.0
var Tag;

import BaseModel from '../../base_model.js';

export default Tag = (function() {
  class Tag extends BaseModel {};

  Tag.setAttributes(['webhook_url', 'webhook_secret']);

  return Tag;

}).call(this);
